module.exports = __webpack_public_path__ + "img/synapse-homepage1.74db382a.png";